import { makeStyles } from '@material-ui/core'
import React, { Fragment, useCallback, useState } from 'react'
import { InputForm } from '../../Component/InputForm'
import { useTranslation } from 'react-i18next'
import { Period, PeriodPicker } from '../../Component/PeriodPicker'
import { Option } from '../../Component/Select'
import { city } from 'ca-plateform-carrier-report-domain'

class CarrierReportStatusValues extends city.colisactiv.platform.carrier.report
  .domain.CarrierReportStatusValues {}

export const carrierReportStatusValues = new CarrierReportStatusValues()

const useStyles = (columnSwitchWidth?: number) =>
  makeStyles(() => ({
    filter: {
      width: '200px',
      marginRight: '10px',
      [`@media (max-width: ${columnSwitchWidth ?? 800}px)`]: {
        width: '100% !important',
        marginRight: '0 !important'
      },
      '& .MuiOutlinedInput-root': {
        height: '44px !important'
      },
      '& .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)':
        {
          marginTop: '0px'
        },
      '& .MuiInputLabel-filled ': {
        transform: ' translate(12px, 25px) scale(1)'
      }
    },
    icon: {
      color: '#9a9a9a',
      cursor: 'pointer'
    },
    container: {
      display: 'flex'
    }
  }))

export interface ReportFiltersModel {
  startDate?: number
  endDate?: number
  status?: string
  carrierId?: string
  territoryId?: string
}

export type Option = {
  label: string
  value: string
}
interface ReportFiltersProps {
  carriers: Option[]
  territories: Option[]
  filterValues: ReportFiltersModel
  onFilterChange: (values: ReportFiltersModel) => void
  columnSwitchWidth?: number
}

export const ReportFilters = (props: ReportFiltersProps) => {
  const {
    carriers,
    filterValues,
    onFilterChange,
    territories,
    columnSwitchWidth
  } = props
  const classes = useStyles(columnSwitchWidth)()
  const { t } = useTranslation()

  const [selectedPeriod, setSelectedPeriod] = useState<Period | undefined>(
    filterValues.startDate == null
      ? undefined
      : {
          startDate: filterValues.startDate!,
          endDate: filterValues.endDate!
        }
  )

  const ReportStatusOptions: Option[] = [
    {
      label: t('app_domain_report_created_status') as string,
      value: carrierReportStatusValues.CREATED.value
    },
    {
      label: t('app_domain_report_published_status') as string,
      value: carrierReportStatusValues.PUBLISHED.value
    },
    {
      label: t('app_domain_report_approved_status') as string,
      value: carrierReportStatusValues.APPROVED.value
    },
    {
      label: t('app_domain_report_invalid_status') as string,
      value: carrierReportStatusValues.INVALID.value
    }
  ]

  const handlePeriodChange = useCallback(
    (period: Period | undefined) => {
      setSelectedPeriod(period)

      onFilterChange({
        ...filterValues,
        startDate: period?.startDate,
        endDate: period?.endDate
      })
    },
    [onFilterChange, filterValues]
  )

  const handleFilterChange = (
    property: keyof ReportFiltersModel,
    value: any
  ) => {
    onFilterChange({
      ...filterValues,
      [property]: value
    })
  }

  return (
    <Fragment>
      <PeriodPicker
        id='filterPeriod'
        placeholder={'Période'}
        period={selectedPeriod}
        onDateChange={handlePeriodChange}
        inputClassName={classes.filter}
        clearable
      />
      <InputForm
        id='Report-filters-carrier'
        inputType={'select'}
        onChange={(carrier) => handleFilterChange('carrierId', carrier)}
        selectOptions={carriers}
        label={''}
        value={filterValues.carrierId}
        placeHolder={t('app_components_bonus_bonusform_carrier')}
        className={`${classes.filter} project-filters`}
        onRemoveValue={() => handleFilterChange('carrierId', undefined)}
      />
      <InputForm
        id='Report-filters-territory'
        inputType={'select'}
        onChange={(territory) => handleFilterChange('territoryId', territory)}
        selectOptions={territories}
        label={''}
        value={filterValues.territoryId}
        placeHolder={t('app_components_bonus_territory')}
        className={`${classes.filter} project-filters`}
        onRemoveValue={() => handleFilterChange('territoryId', undefined)}
      />
      <InputForm
        id='Report-filters-status'
        inputType={'select'}
        onChange={(status) => handleFilterChange('status', status)}
        selectOptions={ReportStatusOptions}
        label={''}
        value={filterValues.status}
        placeHolder={t('app_domain_project_project_status')}
        className={`${classes.filter} project-filters`}
        onRemoveValue={() => handleFilterChange('status', undefined)}
      />
    </Fragment>
  )
}

export default ReportFilters
